export const delay = (ms = 1000) =>
  new Promise((resolve, reject) => {
    globalThis.setTimeout(resolve, ms)
  })
